"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageHash = exports.domainHash = void 0;
const hash_1 = require("@ethersproject/hash");
const domainHash = (message) => hash_1._TypedDataEncoder.hashStruct("EIP712Domain", { EIP712Domain: message.types.EIP712Domain }, message.domain);
exports.domainHash = domainHash;
// Seems that there is no way to set primary type and the first type becomes primary type.
const messageHash = (message) => hash_1._TypedDataEncoder.from((() => {
    const types = Object.assign({}, message.types);
    delete types["EIP712Domain"];
    const primary = types[message.primaryType];
    if (!primary) {
        throw new Error(`No matched primary type: ${message.primaryType}`);
    }
    delete types[message.primaryType];
    return Object.assign({ [message.primaryType]: primary }, types);
})()).hash(message.message);
exports.messageHash = messageHash;
//# sourceMappingURL=utils.js.map